import { EventEmitter } from '@angular/core';
import { Teachers } from '../Elearning-Models';
import { IAPIService } from './API-Service/IAPIService';

export abstract class ITeacherService{
    abstract GetTeachersForAdmin():void;
    abstract teachersAvailableEmitter: EventEmitter<Teachers>;
    abstract GetOrSetTeachers():void;
}

export class TeacherService implements ITeacherService {
    teachersAvailableEmitter: EventEmitter<Teachers> = new EventEmitter<Teachers>();
    teachersAvailable: Teachers

    constructor(private APIService: IAPIService){
    }

    GetTeachersForAdmin() {
        let fName = "GetTeachersForAdmin";
        this.APIService
        .GetTeachersForAdmin()
        .subscribe(data => {
            this.onTeachersForAdminDataAvailable(data);
        });
    }

     
    GetOrSetTeachers(): void {
        if(!this.teachersAvailable){
            this.GetTeachersForAdmin();
            return;
        }

        this.onTeachersForAdminDataAvailable(this.teachersAvailable);
    }

    onTeachersForAdminDataAvailable(data: Teachers){
        this.teachersAvailable = data;
        this.teachersAvailableEmitter.emit(this.teachersAvailable);
    }
}

